import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faRss,
  faSearch,
  faUser,
  faComments,
  faChevronRight,
  faSpinner,
  faMugHot,
  faAtom,
  faPodcast,
  faBullhorn,
  faTimes,
  faEnvelope,
} from '@fortawesome/free-solid-svg-icons'
import {
  faCalendarAlt,
  faClock,
  faCheckCircle,
} from '@fortawesome/free-regular-svg-icons'
import {
  faGithub,
  faTwitter,
  faInstagram,
  faLinkedin,
  faTwitch,
  faAmazon,
  faYoutube,
  faSpotify,
  faFacebook,
} from '@fortawesome/free-brands-svg-icons'
library.add(
  faRss,
  faSearch,
  faUser,
  faCalendarAlt,
  faComments,
  faAtom,
  faClock,
  faChevronRight,
  faCheckCircle,
  faSpinner,
  faGithub,
  faTwitter,
  faInstagram,
  faLinkedin,
  faTwitch,
  faYoutube,
  faAmazon,
  faSpotify,
  faPodcast,
  faMugHot,
  faBullhorn,
  faTimes,
  faFacebook,
  faEnvelope
)
